import '@/i18n/config.ts'
import ReactDOM from 'react-dom/client'
import '@/styles/ui.css'
import '@/styles/index.css'
import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { env } from '@/global/env.ts'
import { AppRouter, AppConfigWrapper } from '@/routes/index.tsx'
import { queryClient, queryClientNextJS } from '@/api/client.ts'
import { SonnerToaster } from '@/components/ui/sonner.tsx'
import { PostHogCustomProvider } from '@/feature/posthog/provider.tsx'
import { SidePanelProvider } from '@/lib/context/sidePanelContext'

const rootElement = document.getElementById(`root`)!

ReactDOM.createRoot(rootElement).render(
  <PostHogCustomProvider>
    <QueryClientProvider client={queryClient}>
      <QueryClientProvider client={queryClientNextJS}>
        <SidePanelProvider>
          <AppConfigWrapper>
            <AppRouter queryClient={queryClient} />
          </AppConfigWrapper>
          <SonnerToaster position='bottom-right' />
          {env.isDev ? <ReactQueryDevtools initialIsOpen={false} buttonPosition='bottom-right' /> : null}
        </SidePanelProvider>
      </QueryClientProvider>
    </QueryClientProvider>
  </PostHogCustomProvider>
)
